import React, { useEffect, useState } from 'react';
import Heading from '../../../../../../generic-components/Heading';
import Button from '../../../../../../generic-components/Button';
import { UserMessage } from '../../../../../../DesignSystem/LiliUserMessage/UserMessage';
import { EditDiscountForm } from './EditDiscountForm';
import { convertValueToUSD } from '../../../../../../helpers/currency.helper';
import { ReactComponent as DiscountIcon } from '../../../../../../assets/svg/discount-new.svg';
import { useStore } from '../../../../../../store';

interface IProps {
  discountType?: string;
  discountAmount?: number;
  subtotalAmount?: number;
  totalAmount?: number;
}

interface IState {
  isDiscountMode: boolean;
  mainTitle: string;
  subTitle: string;
  calcDiscountValue: string;
}

export const DISCOUNT_TYPES = {
  FIXED: 'FIXED',
  PERCENT: 'PERCENT',
};

export const Discount = ({ discountAmount, discountType, subtotalAmount, totalAmount }: IProps) => {
  const [state, setState] = useState<IState>({
    isDiscountMode: false,
    mainTitle: '',
    subTitle: '',
    calcDiscountValue: '',
  });
  const [isEditDiscount, setIsEditDiscount] = useState<boolean>(false);
  const invoiceData = useStore((root) => root.invoiceData);
  const setInvoiceDataToUpdate = useStore((root) => root.setInvoiceDataToUpdate);
  const discountError = () => 'Discount cannot exceed the subtotal amount ';

  const getState = () => {
    if (discountType === DISCOUNT_TYPES.FIXED && discountAmount) {
      setState((prevState) => ({
        ...prevState,
        isDiscountMode: true,
        mainTitle: 'Discount',
        subTitle: `${convertValueToUSD(discountAmount, 2)}`,
        calcDiscountValue: `-${convertValueToUSD(discountAmount, 2)}`,
      }));
    } else if (discountType === DISCOUNT_TYPES.PERCENT && subtotalAmount && discountAmount) {
      setState((prevState) => ({
        ...prevState,
        isDiscountMode: true,
        mainTitle: 'Discount',
        subTitle: `${(discountAmount * 100).toFixed(2)}% on ${convertValueToUSD(subtotalAmount, 2)}`,
        calcDiscountValue: `-${convertValueToUSD(discountAmount * subtotalAmount, 2)}`,
      }));
    } else {
      setState((prevState) => ({
        ...prevState,
        isDiscountMode: false,
        mainTitle: '',
        subTitle: '',
        calcDiscountValue: '',
      }));
    }
  };

  const onRemoveDiscount = () => {
    if (invoiceData) {
      const invoiceDataToUpdate = { ...invoiceData };
      if (
        invoiceDataToUpdate?.invoiceService &&
        'discountType' in invoiceDataToUpdate.invoiceService &&
        'discount' in invoiceDataToUpdate.invoiceService
      ) {
        invoiceDataToUpdate.invoiceService.discountType = null;
        invoiceDataToUpdate.invoiceService.discount = null;
        setInvoiceDataToUpdate(invoiceDataToUpdate);
      }
    }
  };

  useEffect(() => {
    getState();
  }, [discountAmount, discountType, subtotalAmount]);
  return state.isDiscountMode ? (
    <div className='flex flex-col  border-b border-bw03 py-[18px]'>
      <div className='flex items-center justify-between grow  px-[16px]'>
        <div className='flex flex-col'>
          <Heading title={state.mainTitle} className='font-metric text-[14px] text-bw08' />
          <Heading title={state.subTitle} className='font-metric text-[12px] text-bw06' />
        </div>
        <div className='flex flex-col items-end'>
          <Heading title={state.calcDiscountValue} className='font-metric text-[14px] text-red02' />
          <Button
            onClick={onRemoveDiscount}
            className=''
            id=''
            childElement={
              <Heading title='Remove' className='text-action03 font-metric text-[14px] underline hover:text-action02' />
            }
          />
        </div>
      </div>
      {(totalAmount || 0) <= 0 && (
        <p className='text-[12px] text-red02 font-metricR px-[16px] mt-[4px]'>
          {discountError()}
          <span className='text-[12px] text-red02 font-metricRSemibold'>{`$${subtotalAmount}`}</span>
        </p>
      )}
    </div>
  ) : (
    <div className='flex items-center justify-between grow py-[18px] px-[16px] border-b border-bw03'>
      <Button
        onClick={() => setIsEditDiscount(true)}
        className=''
        id=''
        childElement={
          <div className='flex items-center gap-[6px]'>
            <DiscountIcon className='stroke-action03 w-[16px]' />
            <Heading title='Add discount' className='font-metric text-[14px] text-action03 hover:underline' />
          </div>
        }
      />
      <Heading title={convertValueToUSD(0, 2)} className='font-metric text-[14px] text-bw08' />
      {isEditDiscount && (
        <UserMessage
          mainWrapperClassName='backdrop-blur-sm'
          contentWrapperClassName='animate-fadeIn'
          onClick={() => setIsEditDiscount(false)}
          id='clientEditFormWrapper'
        >
          <div className='w-[568px] min-h-[100px] bg-bw00 rounded-[12px]'>
            <EditDiscountForm onClose={() => setIsEditDiscount(false)} totalAmount={subtotalAmount || 0} />
          </div>
        </UserMessage>
      )}
    </div>
  );
};
